export function parseGitHubUrl(gitHubUrl: string) {
  try {
    const url = new URL(gitHubUrl);
    const hostname = url.hostname.toLowerCase();
    const parts = url.pathname.split('/').filter(Boolean);

    if (hostname === 'github.com') {
      return parseGitHubBlobUrl(parts);
    } else if (hostname === 'raw.githubusercontent.com') {
      return parseGitHubRawUrl(parts);
    }
  } catch (error) {
    // Return null if URL parsing fails
  }
  return null;
}

function parseGitHubBlobUrl(parts: string[]) {
  // Expected: /owner/repo/blob/ref/path/to/file
  // Parts: [owner, repo, 'blob', ref, ...path]
  if (parts.length >= 5 && parts[2] === 'blob') {
    const owner = parts[0];
    const repo = parts[1];
    const ref = parts[3];
    const path = parts.slice(4).join('/');
    return { owner, repo, ref, path };
  }
  return null;
}

function parseGitHubRawUrl(parts: string[]) {
  // Expected: /owner/repo/ref/path/to/file
  // Parts: [owner, repo, ref, ...path]
  if (parts.length >= 4) {
    const owner = parts[0];
    const repo = parts[1];
    const ref = parts[2];
    const path = parts.slice(3).join('/');
    return { owner, repo, ref, path };
  }
  return null;
}
